import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { ActivityNoteBlock } from "web_myplann/Activities/Components/ActivityNoteBlock";
import type { ClientActivityNoteItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

const R = Resources.Activity.Detail;

type Props = {
	notes: ClientActivityNoteItemResponseDTO[];
};

export const ActivityNotesSection: FC<Props> = ({ notes }) => {
	const { t } = useResource();

	if (notes.length === 0) {
		return null;
	}

	return (
		<>
			<Typography variant="sectionLabel">{t(R.notes)}</Typography>
			<Stack bgcolor="background.paper" px={1.6} py={1.2} gap={1.6}>
				{notes.map((note) => (
					<ActivityNoteBlock
						key={note.id}
						title={note.title ?? ""}
						content={note.text ?? ""}
					/>
				))}
			</Stack>
		</>
	);
};
